<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">{{ $t('table_title.Course') }}</h5>
                            </a-col>
                        </a-row>
                    </template>
                    <template>
                        <v-data-table
                            :headers="tableColumns"
                            :items="courses"
                            class="elevation-1"
                            show-select
                            v-model="selected"
                            hide-default-footer
                            :loading="isLoadingCourse"
                            :loading-text="$t('cms.loading')"
                            :page="page"
                            :no-data-text="$t('cms.no_data_available')"
                        >
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-dialog v-model="dialogCU" persistent max-width="1000px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mr-2" @click="onAddNewItem()" small>
                                                <v-icon small> mdi-plus </v-icon>
                                                {{ $t('cms.add_new') }}
                                            </v-btn>
                                            <v-btn
                                                color="error"
                                                dark
                                                class="mr-2"
                                                small
                                                v-show="selected.length > 0"
                                                @click="onDeleteMulti"
                                            >
                                                <v-icon small> mdi-delete </v-icon>
                                                &nbsp;{{ $t('form.delete') }}
                                            </v-btn>
                                        </template>

                                        <CourseModal
                                            :cuItem="cuItem"
                                            :formTitle="formTitle"
                                            :closeCU="closeCU"
                                            :save="onSaveItem"
                                            :propsField="tableColumns"
                                            :columns="tableColumns"
                                            :chapters="chapters"
                                            :users="users"
                                            :dialogEdit="dialogEdit"
                                            v-if="dialogCU"
                                        >
                                        </CourseModal>
                                    </v-dialog>

                                    <v-spacer></v-spacer>

                                    <div class="search">
                                        <a-select :default-value="selectedField" @change="handleChangeSelect">
                                            <a-select-option
                                                v-for="(item, index) in fieldsSearch"
                                                :key="index"
                                                :value="item.value"
                                            >
                                                {{ item.title }}
                                            </a-select-option>
                                        </a-select>
                                        <a-input-search
                                            v-model="search"
                                            :placeholder="$t('header.search')"
                                            @change="onSearchItem"
                                        />
                                    </div>

                                    <v-dialog v-model="dialogDelete" max-width="500px">
                                        <ModalDelete :closeDelete="closeDelete" :deleteItemConfirm="deleteItemConfirm">
                                        </ModalDelete>
                                    </v-dialog>
                                    <v-dialog v-model="dialogNoti" max-width="500px">
                                        <ModalNoti :close="closeNoti" :message="formMessage"></ModalNoti>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.thumbnail`]="{ item }">
                                <div class="my-2">
                                    <v-img :src="item.thumbnail || noImage" alt="" class="table-image" />
                                </div>
                            </template>
                            <template v-slot:[`item.title`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.title }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.note`]="{ item }">
                                <div class="my-2 line-clamp-2">
                                    <span>{{ item.note }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.created_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.created_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.updated_at_unix_timestamp`]="{ item }">
                                <div class="my-2">
                                    <span>{{ getFormatDate(+item.updated_at_unix_timestamp) }}</span>
                                </div>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <router-link :to="{ path: `/record-of-course/${item.id}` }">
                                    <v-btn color="indigo" class="mr-2" dark small>
                                        <v-icon left> mdi mdi-format-list-bulleted-type </v-icon>
                                        &nbsp;{{ $t('cms.everyone_course_status') }}
                                    </v-btn>
                                </router-link>
                                <v-btn color="info" class="mr-2" dark small @click="onUpdateItem(item)">
                                    <v-icon small> mdi-pencil </v-icon>
                                    &nbsp;{{ $t('form.edit') }}
                                </v-btn>
                                <v-btn color="error" dark small @click="onDeleteItem(item)">
                                    <v-icon small> mdi-delete </v-icon>
                                    &nbsp;{{ $t('form.delete') }}
                                </v-btn>
                            </template>
                        </v-data-table>
                        <div class="text-center py-5">
                            <f-pagination
                                v-model="page"
                                :pageSize="coursesPagination.pageSize"
                                :totalItems="coursesPagination.totalItems"
                                :disabled="isLoadingCourse"
                            />
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>
        <f-notification-dialog
            class="dialogNoti"
            :isShowDialog="isShowDialogMulti"
            width="500px"
            :title="$t('cms.delete_multiple')"
            :content="$t('cms.confirm_delete_multiple')"
            :actions="actionsMulti"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CourseModal from '../../components/CMS/Modal/Course.vue';
import ModalDelete from '../../components/CMS/Modal/Delete.vue';
import ModalNoti from '../../components/CMS//Modal/Noti.vue';
import { CRUD } from '../../constants';
import { mixinToasts, mixinFormats, mixinLoadings } from '../../mixins';
import * as _ from 'lodash';

export default {
    mixins: [mixinToasts, mixinFormats, mixinLoadings],
    components: { CourseModal, ModalDelete, ModalNoti },

    data() {
        return {
            tableTitle: this.$t('cms.course_table'),
            tableColumns: [
                { text: this.$t('form.image'), value: 'thumbnail', width: '120px', sortable: false },
                { text: this.$t('form.name'), value: 'title', width: '200px', sortable: false },
                { text: this.$t('form.administrator_note'), value: 'note', width: '200px', sortable: false },
                {
                    text: this.$t('form.created_at'),
                    value: 'created_at_unix_timestamp',
                    width: '200px',
                    sortable: false,
                },
                {
                    text: this.$t('form.updated_at'),
                    value: 'updated_at_unix_timestamp',
                    width: '200px',
                    sortable: false,
                },
                { text: this.$t('cms.action'), value: 'actions', width: '460px', sortable: false },
            ],
            fieldsSearch: [
                {
                    title: this.$t('form.name'),
                    value: 'title',
                },
            ],
            selectedField: 'title',
            search: '',
            page: 1,
            cuIndex: -1,
            cuItem: {},
            defaultItem: {
                title: '',
                thumbnail: '',
                note: '',
                description: '',
                array_hashtag: [],
                course_settings: [],
                materials: [],
                status: true,
            },
            cuItemDelete: {},
            dialogCU: false,
            dialogDelete: false,
            dialogNoti: false,
            dialogEdit: false,
            isShowDialogMulti: false,
            actionsMulti: [],
            selected: [],
            noImage: require('../../assets/images/no_image.jpg'),
            formMessage: '',
        };
    },
    computed: {
        ...mapState('course', ['isLoadingCourse', 'courses', 'coursesOne', 'coursesPagination']),
        ...mapState('chapter', ['isLoadingChapter', 'chapters', 'chaptersPagination']),
        ...mapState('user', ['isLoadingUser', 'users', 'usersPagination']),
        formTitle() {
            return this.cuIndex === -1 ? this.$t('cms.new_item') : this.$t('cms.edit_item');
        },
    },
    async mounted() {
        await this.getCourseList({ page: this.page, field: this.selectedField, search: this.search });
    },
    watch: {
        page(val) {
            this.getCourseList({ page: val, field: this.selectedField, search: this.search });
        },
        dialogCU(val) {
            val || this.closeCU();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
        dialogNoti(val) {
            val || this.closeNoti();
        },
    },
    methods: {
        ...mapActions('course', [
            'getCourses',
            'getCoursesOne',
            'postNewCourse',
            'putOneCourse',
            'deleteOneCourse',
            'deleteMultiCourses',
        ]),
        ...mapActions('chapter', ['getChaptersSections']),
        async getCourseList(data) {
            this.page = data?.page || 1;
            this.selectedField = data?.field;
            this.search = data?.search || '';
            await this.getCourses(data);
            await this.getChaptersSections({ page: 0, field: 'title', search: '', limit: 9999 });
        },
        onAddNewItem() {
            this.dialogEdit = false;
            this.dialogCU = true;
            this.cuItem = Object.assign({}, this.defaultItem);
        },
        async onUpdateItem(item) {
            this.dialogEdit = true;
            this.dialogCU = true;
            this.cuIndex = this.courses.indexOf(item);
            this.cuItem = Object.assign({}, item);
            await this.getCoursesOne(item.id);
        },
        onDeleteItem(item) {
            this.cuIndex = this.courses.indexOf(item);
            this.cuItemDelete = Object.assign({}, item);
            this.dialogDelete = true;
        },
        onDeleteMulti() {
            this.isShowDialogMulti = true;
            this.actionsMulti = [
                {
                    title: this.$t('cancel'),
                    function: this.cancelMulti,
                },
                {
                    title: this.$t('yes'),
                    function: this.agreeMulti,
                },
            ];
        },
        async agreeMulti() {
            this.isShowDialogMulti = false;
            this.showLoading();
            const arr = this.selected.map((item) => item.id);
            if (arr.length > 0) {
                const res = await this.deleteMultiCourses(JSON.stringify(arr));
                if (res?.isSuccess) {
                    this.selected = [];
                    await this.getCourseList({ page: this.page, field: this.selectedField, search: this.search });
                    this.showSuccess(CRUD.DELETE);
                } else {
                    this.showError(res?.data);
                }
            }
            this.hideLoading();
        },
        cancelMulti() {
            this.isShowDialogMulti = false;
        },
        async deleteItemConfirm() {
            this.closeDelete();
            this.showLoading();
            const res = await this.deleteOneCourse(this.cuItemDelete.id);
            if (res?.isSuccess) {
                await this.getCourseList({ page: this.page, field: this.selectedField, search: this.search });
                this.showSuccess(CRUD.DELETE);
            } else {
                this.showError(res?.data);
            }
            this.hideLoading();
        },
        closeCU() {
            this.dialogCU = false;
            this.$nextTick(() => {
                this.cuItem = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.cuItemDelete = Object.assign({}, this.defaultItem);
                this.cuIndex = -1;
            });
        },
        closeNoti() {
            this.dialogNoti = false;
        },
        async onSaveItem(course__settings, callback) {
            this.showLoading();
            if (this.cuIndex === -1) {
                const body = {
                    ...this.cuItem,
                    array_hashtag:
                        this.cuItem.array_hashtag?.length > 0
                            ? this.cuItem.array_hashtag.map((item) => item.replace(/\s/g, ''))
                            : [],
                    course_settings: course__settings,
                    materials: this.cuItem.materials,
                };
                const res = await this.postNewCourse(body);
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getCourseList({ page: 1, field: 'title', search: '' });
                    this.showSuccess(CRUD.CREATE);
                } else {
                    this.showError(res?.data);
                }
            } else {
                const body = {
                    ...this.cuItem,
                    array_hashtag: this.cuItem.array_hashtag.map((item) => item.replace(/\s/g, '')),
                    course_settings: course__settings,
                    materials: this.cuItem.materials,
                };
                const res = await this.putOneCourse(body);
                callback(res?.isSuccess);
                if (res?.isSuccess) {
                    await this.getCourseList({ page: this.page, field: this.selectedField, search: this.search });
                    this.showSuccess(CRUD.UPDATE);
                } else {
                    this.showError(res?.data);
                }
            }
            this.hideLoading();
        },
        onSearchItem: _.debounce(function (e) {
            this.getCourseList({ page: 1, field: this.selectedField, search: this.search });
        }, 500),
        handleChangeSelect(value) {
            this.getCourseList({ page: 1, field: value, search: this.search });
        },
    },
};
</script>

<style lang="scss">
.table-image {
    width: 45px;
    height: 45px;
}

.search {
    & .ant-select {
        margin-right: 10px;
        width: 120px;
    }

    & .ant-input-search {
        width: 500px;
    }
}
</style>
